// extracted by mini-css-extract-plugin
export default {"clickableItem":"itemOnPopup_clickableItem__o0nvJ","clickableItemUnderlined":"itemOnPopup_clickableItemUnderlined__muoSJ","itemOnPopup":"itemOnPopup_itemOnPopup__guNqt"};